import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Contents } from '../../../Common/rules.module';
import { RulesComponent } from '../rules/rules.component';
import { GetDataService } from '../../../services/userService/get-data.service';
import { LoaderComponent } from '../../../Common/loader/loader.component';
import { showCustomeAlert } from '../../../services/Alert/alert.service';

declare var collapsedDiv: any;
declare var closePopovers: any;

@Component({
  selector: 'app-section',
  imports: [CommonModule, FormsModule, RulesComponent,LoaderComponent],
  templateUrl: './section.component.html',
  styleUrl: './section.component.scss'
})
export class SectionComponent implements OnInit {
  sectionId: any
  section: Contents | undefined = undefined;
  sections: Contents[] = [];
  filteredSection: Contents[] = [];
  constructor(private _activeRoute: ActivatedRoute, private _service: GetDataService, private _route: Router) { }

  ngOnInit(): void {
    this.sectionId = this._activeRoute.snapshot.paramMap.get("id");
    let divId = this._activeRoute.snapshot.paramMap.get("div");
    this._service.getData().subscribe((res:any) => {
      this.sections = res;
      this.section = this.sections.find((elem: any, idx) => elem.id == this.sectionId);

      setTimeout(() => {
        if (divId) {
          let collapsedDiv: any = this.section?.subContents?.filter((rule: any) => rule.id == divId);
          this.callJs(collapsedDiv[0].id);
        }
      }, 10);
    }, (error) => {
      showCustomeAlert("error","Something went wrong. Please refresh the page..","Error");  
    });
  }

  callJs(divId: any) {
    collapsedDiv(divId);
  }

  closePopOver() {
    closePopovers()
  }
  goBack() {
    this._route.navigate(['/user']);
  }
}
